export default __webpack_public_path__ + "static/media/image-57.442fcf1f.png";